import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function TransparentInspection() {
  const listItems = ['Photos and video from your vehicle', 'Technician notes explaining what was found', 'Repair recommendations prioritized by urgency', 'Clear estimates before any work begins'];
  return <section className="py-20 px-4 bg-brand-light" data-id="element-191">
      <div className="max-w-4xl mx-auto" data-id="element-192">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-193">
          <img src="https://cdn.magicpatterns.com/uploads/v5w4cpb7uAJvjUTD8b3jRB/Lancer_Circle3x.png" alt="Lancer Service - Auto Repair & Maintenance" className="w-40 h-40 md:w-52 md:h-52 mx-auto mb-8 drop-shadow-lg" data-id="element-194" />
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-195">
            Transparency built into every inspection
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-dark mb-6" data-id="element-196">
            No guessing.
            <br data-id="element-197" />
            You see the problem yourself.
          </h2>
          <div className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed space-y-4" data-id="element-198">
            <p data-id="element-199">
              Before any repair begins, you'll see exactly what our technicians
              see.
            </p>
            <p data-id="element-200">
              Every inspection at Lancer includes a digital vehicle inspection
              report sent directly to your phone.
            </p>
          </div>
        </motion.div>

        <div className="bg-white rounded-2xl p-8 md:p-12 border border-gray-200 shadow-sm mb-10" data-id="element-201">
          <p className="font-bold text-brand-dark text-lg mb-6" data-id="element-202">
            You'll receive:
          </p>
          <ul className="space-y-6" data-id="element-203">
            {listItems.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4" data-id="element-204">
                <CheckCircleIcon className="w-6 h-6 text-brand-accent flex-shrink-0 mt-0.5" data-id="element-205" />
                <span className="text-lg text-gray-800 font-medium" data-id="element-206">
                  {item}
                </span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center space-y-2" data-id="element-207">
          <p className="text-brand-dark font-bold text-xl max-w-2xl mx-auto" data-id="element-208">
            Nothing starts without your approval.
          </p>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-209">
            And if something isn't urgent, we'll tell you that too.
          </p>
        </motion.div>
      </div>
    </section>;
}